"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15.05 12.81 6.56 4.32a.996.996 0 0 0-1.41 0L2.32 7.15c-.39.39-.39 1.02 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83c.39-.39.39-1.02 0-1.41m-.7086 4.9462 1.4142-1.4142 4.2427 4.2426-1.4143 1.4142z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "18.5",
  cy: "5.5",
  r: "3.5"
}, "1")], 'SportsCricket');